import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard from './components/vx-card/VxCard.vue'
import VxList from './components/vx-list/VxList.vue'
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon from './components/FeatherIcon.vue'
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)

// Font awesome
import './icons/fontAwesome.js'

// v-select component
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement =>
      createElement('feather-icon', {
        props: {
          icon: 'XIcon',
          svgClasses: 'w-4 h-4 mt-1'
        }
      })
  },
  OpenIndicator: {
    render: createElement =>
      createElement('feather-icon', {
        props: {
          icon: 'ChevronDownIcon',
          svgClasses: 'w-5 h-5'
        }
      })
  }
})

Vue.component('v-select', vSelect)

//vue-persian-datetime-picker component
import DatePicker from 'vue-persian-datetime-picker'
Vue.use(DatePicker, {
  name: 'date-picker',
  props: {
    inputFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    inputClass: '',
    altFormat: 'HH:mm dddd, DD MMMM YYYY',
    jumpMinute: 15,
    roundMinute: true,
    color: '#7367f0',
    autoSubmit: true,
    clearable: false
  }
})

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar, {
  options: {
    maxScrollbarLength: 60,
    wheelSpeed: 0.5,
    swipeEasing: true
  }
})
